const SPACE_SPLITTER = /\s+/;

export function createIdFromQuery(query) {
  query = (!query) ? '' : query.trim().split(SPACE_SPLITTER).join(' ');
  return `s${query}`.toLowerCase();
}

export function createIdByParams(params) {
  if(typeof params !== 'object') {
    return createIdFromQuery(params);
  }

  const idString = Object.entries(params)
      .map(([key, value]) => `${key}-${value}`)
      .join('_');

  return idString;
}